import type React from 'react';
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import '~/common/pdfWorker';

interface Props {
  fileURL: string;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  pageNum: number;
  setTotalPages: React.Dispatch<React.SetStateAction<number>>;
  scale: number;
}

export default function PDFViewer({ fileURL, setLoading, pageNum, setTotalPages, scale }: Props) {
  return (
    <div>
      <Document
        file={fileURL}
        onLoadSuccess={(pdf) => {
          setLoading(false);
          setTotalPages(pdf.numPages);
        }}
      >
        <Page scale={scale} pageNumber={pageNum} renderTextLayer={false} />
      </Document>
    </div>
  );
}
